"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _lodash = _interopRequireDefault(require("lodash.isequal"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function getContext(_ref) {
  var _ref$state = _ref.state,
      video = _ref$state.video,
      project = _ref$state.project,
      outputs = _ref$state.outputs,
      saving = _ref$state.saving,
      canUpdateVideo = _ref$state.canUpdateVideo,
      hasUpdatePermission = _ref$state.hasUpdatePermission,
      hasDeleteAssetsPermission = _ref$state.hasDeleteAssetsPermission,
      hasArchiveAssetsPermission = _ref$state.hasArchiveAssetsPermission,
      costReviewEnabled = _ref$state.costReviewEnabled,
      hasCostApprovalPermission = _ref$state.hasCostApprovalPermission,
      shouldShowPendingApprovalInformation = _ref$state.shouldShowPendingApprovalInformation,
      shouldShowPendingApprovalButtons = _ref$state.shouldShowPendingApprovalButtons,
      isReturnFeedbackModalVisible = _ref$state.isReturnFeedbackModalVisible,
      showPaymentInvoiceModal = _ref$state.showPaymentInvoiceModal,
      commentFilterClip = _ref$state.commentFilterClip,
      selectedDrawerAssets = _ref$state.selectedDrawerAssets,
      _ref$actions = _ref.actions,
      updateProject = _ref$actions.updateProject,
      deleteAssets = _ref$actions.deleteAssets,
      archiveAssets = _ref$actions.archiveAssets,
      archiveAsset = _ref$actions.archiveAsset,
      updateVideo = _ref$actions.updateVideo,
      updateOutputs = _ref$actions.updateOutputs,
      onSave = _ref$actions.onSave,
      submitVideo = _ref$actions.submitVideo,
      onSaveOutputs = _ref$actions.onSaveOutputs,
      setCommentFilterClip = _ref$actions.setCommentFilterClip,
      returnFeedback = _ref$actions.returnFeedback,
      openPaymentsInvoiceModal = _ref$actions.openPaymentsInvoiceModal,
      fetchAssetsForResource = _ref$actions.fetchAssetsForResource;
  return {
    state: {
      video: video,
      project: project,
      outputs: outputs,
      saving: saving,
      canUpdateVideo: canUpdateVideo,
      hasUpdatePermission: hasUpdatePermission,
      hasDeleteAssetsPermission: hasDeleteAssetsPermission,
      hasArchiveAssetsPermission: hasArchiveAssetsPermission,
      costReviewEnabled: costReviewEnabled,
      hasCostApprovalPermission: hasCostApprovalPermission,
      shouldShowPendingApprovalInformation: shouldShowPendingApprovalInformation,
      shouldShowPendingApprovalButtons: shouldShowPendingApprovalButtons,
      isReturnFeedbackModalVisible: isReturnFeedbackModalVisible,
      showPaymentInvoiceModal: showPaymentInvoiceModal,
      commentFilterClip: commentFilterClip,
      selectedDrawerAssets: selectedDrawerAssets
    },
    actions: {
      updateProject: updateProject,
      deleteAssets: deleteAssets,
      archiveAssets: archiveAssets,
      archiveAsset: archiveAsset,
      updateVideo: updateVideo,
      updateOutputs: updateOutputs,
      onSave: onSave,
      submitVideo: submitVideo,
      onSaveOutputs: onSaveOutputs,
      setCommentFilterClip: setCommentFilterClip,
      returnFeedback: returnFeedback,
      openPaymentsInvoiceModal: openPaymentsInvoiceModal,
      fetchAssetsForResource: fetchAssetsForResource
    }
  };
}

function contextIsEqual(newState, oldState) {
  return (0, _lodash.default)(getContext(newState), getContext(oldState));
}

var _default = (0, _memoizeOne.default)(getContext, contextIsEqual);

exports.default = _default;